import React, { useState } from 'react';
import './Write.css';
import { useContext } from 'react';
import { Context } from '../../context/Context.js';
import axios from 'axios';

export const Write = () => {
  const { user } = useContext(Context);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [file, setFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newPost = {
      username: user.username,
      title,
      desc,
    };
    if (file) {
      const data = new FormData();
      const fileName = Date.now() + '-' + file.name;
      data.append('name', fileName);
      data.append('file', file);
      newPost.photo = fileName;

      try {
        await axios.post('https://mern-blog-4tol.onrender.com/api/upload', data);
      } catch (err) {
        console.log(err);
      }
    }
    try {
      const response = await axios.post('https://mern-blog-4tol.onrender.com/api/posts', newPost);
      window.location.replace('https://rana-mernblog.netlify.app/postDetails/' + response.data._id);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="write">
      {file && (
        <img src={URL.createObjectURL(file)} alt="" className="writeImg" />
      )}
      <form className="writeForm" onSubmit={handleSubmit}>
        <div className="writeFormGroup">
          <label htmlFor="fileInput">
            <i className="writeIcon fas fa-plus"></i>
          </label>
          <input
            type="file"
            id="fileInput"
            style={{ display: 'none' }}
            onChange={(e) => setFile(e.target.files[0])}
          />
          <input
            type="text"
            placeholder="Enter Title..."
            className="writeInput"
            autoFocus={true}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="writeFormGroup">
          <textarea
            placeholder="Tell your story..."
            type="text"
            className="writeInput writeText"
            onChange={(e) => setDesc(e.target.value)}
          ></textarea>
        </div>
        <button className="glow-on-hover" type="submit">
          Publish 
        </button>
      </form>
    </div>
  );
};
